<template>
  <div :class="headerClass">

    <!-- Modal loadingModal -->
    <div class="modal fade" ref="loadingModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="loadingLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title text-black" id="loadingLabel">Connecting to Payment Platform</h4>
                <br>
                <div id="lockingError" class="text-black">
                  <p>If you are using Internet Explorer or the spinner keeps on spinning, there has been some kind of error (get Bill Gates in here!).</p>
                  <p class="mb-0">Please refresh and try again, or <a :href="contactRoute" class="font-weight-bold">Contact Us</a></p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col" id="ajaxImg">
                <img class="mx-auto d-block" src="/img/ajax_lg.gif" alt="Awaiting server to retrieve the information"> <!-- TODO: see if we can use the Vue Loading spinner -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- .modal loadingModal -->

    <template v-if="displayCheckout">
      <div class="container-fluid">
        <div class="row py-4">
          <div class="col text-center pt-4">
            <h2 v-if="cartOrSale == 'cart'" class="h1 text-uppercase font-weight-bold">Review your shopping cart&hellip;</h2>
            <h2 v-else-if="cartOrSale == 'sale' && sale.transactions && sale.transactions.length > 0" class="h1 text-uppercase font-weight-bold">Conclude your purchase&hellip;</h2>
            <h2 v-else-if="fromPbl" class="h1 text-uppercase font-weight-bold">Pay-By-Link: Pay For Your Sale&hellip;</h2>
            <h2 v-else-if="cartOrSale == 'sale'" class="h1 text-uppercase font-weight-bold">Pay For Your Sale&hellip;</h2>

            <button v-if="cartOrSale == 'cart' && fromIframe" @click="addExtraItemsToCart" class="btn" :class="$deploymentCurrent == 'trappedinfiction' ? 'btn-trappedinfiction-dark' : 'btn-tempus-blue-400'">
              <span class="material-icons" style="position: relative; top: 5px;">add_shopping_cart</span> Add Another Item
            </button>
          </div>
        </div>
        <div class="row">
          <div class="mb-4" :class="(($mq == 'lg' || $mq == 'md' || $mq == 'sm' || $mq == 'xs') ? 'order-12' : '') + (fromIframe ? ' col' : ' col-xl-10')">
            <div class="checkout-table checkout-table-dark">
              <div class="checkout-table-header">
                <div class="checkout-table-row">
                  <div v-if="($mq == 'xs')" class="ml-2">
                    <p class="mb-0">Details</p>
                    <p class="mb-0">Qty</p>
                    <p class="mb-0">Price</p>
                  </div>
                  <template v-else-if="($mq == 'sm' || $mq == 'md')">
                    <div class="checkout-table-column checkout-table-column-px140">Item</div>
                    <div class="checkout-table-column" :class="$mq == 'md' ? '' : 'checkout-table-column-px300'">
                      <div>
                        <p class="mb-0">Details</p>
                        <p class="mb-0">Qty</p>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="checkout-table-column checkout-table-column-px100 text-center">Tools</div>
                    <div class="checkout-table-column" :class="($mq == 'lg' || $mq == 'xl') ? 'checkout-table-column-px180' : 'checkout-table-column-px380'">Item</div>
                    <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px260' : 'checkout-table-column-px160'">Qty</div>  <!-- <th :style="locationChildPricing ? 'width: 230px;' : 'width: 145px;'">Qty</th> -->
                    <div class="checkout-table-column my-auto">Details</div>
                  </template>
                  <div v-if="($mq != 'xs')" class="checkout-table-column checkout-table-column-px100 ml-auto" :class="($mq == 'sm') ? 'text-right' : ''">Price</div>
                </div>
              </div>
              <div class="checkout-table-body">
                <template v-for="item in sortedItems">
                  <item-details-row
                    :type="cartOrSale"
                    :item="item"
                    :cart="cart"
                    :sale="sale"
                    :location="location"
                    :location-child-pricing="locationChildPricing"
                    :room-products="roomProducts"
                    :pricing-style="pricingStyle"
                    :allow-zero-adults="allowZeroAdults"
                    @add-product="addProduct"
                    @cart-updated="cartRefreshed"
                    @sale-updated="saleUpdatedFromItemDetailsRow"></item-details-row>
                </template>
              </div>

              <template v-if="cartOrSale == 'sale' && sale.transactions && sale.transactions.length"> <!-- TRANSACTIONS -->
                <!--
                If there are transactions, it needs to be clear what has been paid (and how), and what remains to be paid.
                The best way to do that was to break it down into segments, if there are no transaction (or is a Cart Sale)
                the other template is fine
                -->
                <div class="checkout-table-footer for-total">
                  <div class="checkout-table-row">
                    <template v-if="$mq == 'xs'">
                      <div class="checkout-table-column text-left">
                        <h4 class="mb-0">{{ isDiscounted ? 'SUBTOTAL:' : 'TOTAL:' }} {{ sale.subtotal_amount | money}}</h4>
                      </div>
                    </template>
                    <template v-if="$mq == 'sm'">
                      <div class="checkout-table-column checkout-table-column-px140"></div>
                      <div class="checkout-table-column checkout-table-column-px300 text-right">
                        <h4 class="mb-0">{{ isDiscounted ? 'SUBTOTAL:' : 'TOTAL:' }}</h4>
                      </div>
                    </template>
                    <template v-else>
                      <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                      <div class="checkout-table-column checkout-table-column-px380"></div>
                      <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                      <div class="checkout-table-column text-right" style="max-width: 600px;">
                        <h4 class="mb-0">{{ isDiscounted ? 'SUBTOTAL:' : 'TOTAL:' }}</h4>
                      </div>
                    </template>

                    <div v-if="isDiscounted" class="checkout-table-column checkout-table-column-px100" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''">
                      <h4 class="mb-0"style="letter-spacing: 0;">{{ sale.subtotal_amount | money}}</h4>
                    </div>
                    <div v-else class=" checkout-table-column checkout-table-column-px100" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''">
                      <h4 class="mb-0" style="letter-spacing: 0;">{{ sale.total_amount | money}}</h4>
                    </div>
                  </div>

                  <template v-if="isDiscounted">
                    <div class="checkout-table-row">
                      <template v-if="($mq == 'xs' || $mq == 'sm')">
                        <div class="checkout-table-column checkout-table-column-px140"></div>
                        <div class="checkout-table-column checkout-table-column-px300 text-right">
                          <p class="mb-0">({{ discountDescription }}) DISCOUNT:</p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                        <div class="checkout-table-column checkout-table-column-px380"></div>
                        <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                        <div class="checkout-table-column text-right" style="max-width: 600px;">
                          <h5 class="mb-0">({{ discountDescription }}) DISCOUNT:</h5>
                        </div>
                      </template>
                      <div class="checkout-table-column checkout-table-column-px100 text-red" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''" style="letter-spacing: 0;">
                        <p class="mb-0">-{{ discountedAmount | money }}</p>
                      </div>
                    </div>
                    <div class="checkout-table-row">
                      <template v-if="($mq == 'xs' || $mq == 'sm')">
                        <div class="checkout-table-column checkout-table-column-px140"></div>
                        <div class="checkout-table-column checkout-table-column-px300 text-right">
                          <p class="mb-0">DISCOUNTED TOTAL:</p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                        <div class="checkout-table-column checkout-table-column-px380"></div>
                        <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                        <div class="checkout-table-column text-right font-weight-bold" style="max-width: 600px;">
                          <h4 class="mb-0">DISCOUNTED TOTAL:</h4>
                        </div>
                      </template>
                      <div class="checkout-table-column checkout-table-column-px100 font-weight-bold" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''">
                        <h4 class="mb-0" style="letter-spacing: 0;">{{ discountedTotal | money }}</h4>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="checkout-table-body text-tempus-blue-tint">
                  <div class="checkout-table-row">
                    <template v-if="($mq == 'xs' || $mq == 'sm')">
                      <div class="checkout-table-column checkout-table-column-px140"></div>
                      <div class="checkout-table-column checkout-table-column-px300 text-right"><h4 class="mb-0">{{ sale.transactions.count }} {{ sale.transactions.count == 1 ? 'Transaction' : 'Transactions' }} Received</h4></div>
                    </template>
                    <template v-else>
                      <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                      <div class="checkout-table-column checkout-table-column-px380"></div>
                      <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                      <div class="checkout-table-column text-right" style="max-width: 600px;">
                        <h4 class="mb-0">{{ sale.transactions.count }} {{ sale.transactions.count == 1 ? 'Transaction' : 'Transactions' }} Received</h4>
                      </div>
                    </template>
                    <div class="checkout-table-column checkout-table-column-px100 font-weight-bold" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''">
                      <h4 class="mb-0" style="letter-spacing: 0;">{{ sale.totalTransactionsAmount | money }}</h4>
                    </div>
                  </div>
                  <template v-for="transaction in sale.transactions">
                    <div class="checkout-table-row">
                      <template v-if="($mq == 'xs' || $mq == 'sm')">
                        <div class="checkout-table-column checkout-table-column-px140"></div>
                        <div class="checkout-table-column checkout-table-column-px300 text-right">{{ transaction.transaction_type.long }} &mdash; {{ transaction.created_at | moment('DD/MM/YYYY HH:mm') }}</div>
                      </template>
                      <template v-else>
                        <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                        <div class="checkout-table-column checkout-table-column-px380"></div>
                        <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                        <div class="checkout-table-column text-right" style="max-width: 600px;">
                          {{ transaction.transaction_type.long }} &mdash; {{ transaction.created_at | moment('ddd, Do MMM YYYY, h:mm a') }} for
                        </div>
                      </template>
                      <div class="checkout-table-column checkout-table-column-px100" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''" style="letter-spacing: 0;">
                        {{ transaction.amount | money }}
                      </div>
                    </div>
                  </template>
                </div>

                <div class="checkout-table-footer for-total">
                  <div class="checkout-table-row">
                    <div class="checkout-table-row">
                      <template v-if="($mq == 'xs' || $mq == 'sm')">
                        <div class="checkout-table-column checkout-table-column-px140"></div>
                        <div class="checkout-table-column checkout-table-column-px300 text-right">
                          <h4 class="font-weight-bold mb-0">LEFT TO PAY:</h4>
                        </div>
                      </template>
                      <template v-else>
                        <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                        <div class="checkout-table-column checkout-table-column-px380"></div>
                        <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                        <div class="checkout-table-column text-right font-weight-bold" style="max-width: 600px;">
                          <h4 class="font-weight-bold mb-0">LEFT TO PAY:</h4>
                        </div>
                      </template>
                      <div class="checkout-table-column checkout-table-column-px100 font-weight-bold" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''">
                        <h4 class="font-weight-bold mb-0" style="letter-spacing: 0;">{{ sale.left_to_pay | money }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </template> <!-- /TRANSACTIONS -->

              <template v-else> <!-- ! (cartOrSale == 'sale' && sale.transactions.length) -->
                <div class="checkout-table-footer for-discounting">
                  <div class="checkout-table-row">
                    <template v-if="$mq == 'xs'">
                      <div class="checkout-table-column">
                        <h4 class="mb-0" style="letter-spacing: 0;">
                          Subtotal:
                          <template v-if="cartOrSale == 'cart'">{{ cart.price | money}}</template>
                          <template v-if="cartOrSale == 'sale'">{{ sale.subtotal_amount | money}}</template>
                        </h4>
                      </div>
                    </template>
                    <template v-else-if="$mq == 'sm'">
                      <div class="checkout-table-column checkout-table-column-px140"></div>
                      <div class="checkout-table-column checkout-table-column-px300 text-right">
                        <h4 class="mb-0">Subtotal:</h4>
                      </div>
                    </template>
                    <template v-else>
                      <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                      <div class="checkout-table-column checkout-table-column-px380"></div>
                      <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                      <div class="checkout-table-column text-right" style="max-width: 600px;">
                        <h4 class="mb-0">Subtotal:</h4>
                      </div>
                    </template>

                    <template v-if="$mq != 'xs'">
                      <div class="checkout-table-column checkout-table-column-px100" :class="$mq == 'sm' ? 'text-right' : ''">
                        <h4 v-if="cartOrSale =='cart'" class="mb-0" style="letter-spacing: 0;">{{ cart.price | money}}</h4>
                        <h4 v-if="cartOrSale =='sale'" class="mb-0" style="letter-spacing: 0;">{{ sale.subtotal_amount | money}}</h4>
                      </div>
                    </template>
                  </div>

                  <template v-if="isDiscounted">
                    <div class="checkout-table-row">
                      <template v-if="$mq == 'xs'">
                        <div class="checkout-table-column">
                          <h4 class="mb-0" style="letter-spacing: 0;">
                            DISCOUNT ({{ discountDescription }}):</h4>
                          </h4>
                          <p class="mb-0 text-red">-{{ discountedAmount | money }}</p>
                        </div>
                      </template>
                      <template v-else-if="$mq == 'sm'">
                        <div class="checkout-table-column checkout-table-column-px140"></div>
                        <div class="checkout-table-column checkout-table-column-px300 text-right">
                          <p class="mb-0">({{ discountDescription }}) DISCOUNT:</p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                        <div class="checkout-table-column checkout-table-column-px380"></div>
                        <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                        <div class="checkout-table-column text-right" style="max-width: 600px;">
                          <h5 class="mb-0">({{ discountDescription }}) DISCOUNT:</h5>
                        </div>
                      </template>
                      <div v-if="$mq != 'xs'" class="checkout-table-column checkout-table-column-px100 text-red" :class="$mq == 'sm' ? 'text-right' : ''" style="letter-spacing: 0;">
                        <h4 class="mb-0">-{{ discountedAmount | money }}</h4>
                      </div>
                    </div>
                    <div class="checkout-table-row">
                      <template v-if="$mq == 'xs'">
                        <div class="checkout-table-column">
                          <h4 class="mb-0" style="letter-spacing: 0;">DISCOUNTED TOTAL:</h4>
                          <h4 class="my-2">{{ discountedTotal | money }}</h4>
                        </div>
                      </template>
                      <template v-else-if="$mq == 'sm'">
                        <div class="checkout-table-column checkout-table-column-px140"></div>
                        <div class="checkout-table-column checkout-table-column-px300 text-right">
                          <p class="mb-0">DISCOUNTED TOTAL:</p>
                        </div>
                      </template>
                      <template v-else>
                        <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                        <div class="checkout-table-column checkout-table-column-px380"></div>
                        <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                        <div class="checkout-table-column text-right font-weight-bold" style="max-width: 600px;">
                          <h4 class="mb-0">DISCOUNTED TOTAL:</h4>
                        </div>
                      </template>
                      <div v-if="$mq != 'xs'" class="checkout-table-column checkout-table-column-px100 font-weight-bold" :class="($mq == 'xs' || $mq == 'sm') ? 'text-right' : ''" style="letter-spacing: 0;">
                        <h4 class="mb-0">{{ discountedTotal | money }}</h4>
                      </div>
                    </div>
                  </template>

                  <div v-if="(cartOrSale == 'cart' && cart.priceVat) || (cartOrSale == 'sale' && sale.total_amount_vat)" class="checkout-table-row" id="tax">
                    <template v-if="$mq == 'xs'">
                      <div class="checkout-table-column">
                        <h4 class="mb-0" style="letter-spacing: 0;">
                          <template v-if="$currencyCode == 'USD'">
                            Sales Tax<template v-if="taxIncludedInPrice"> (included)</template>:
                          </template>
                          <template v-else>
                            VAT<template v-if="taxIncludedInPrice"> (included)</template>:
                          </template>
                          <template v-if="cartOrSale == 'cart'">{{ cart.priceVat | money}}</template>
                          <template v-if="cartOrSale == 'sale'">{{ sale.total_amount_vat | money}}</template>
                        </h4>
                      </div>
                    </template>
                    <template v-else-if="$mq == 'sm'">
                      <div class="checkout-table-column checkout-table-column-px140"></div>
                      <div class="checkout-table-column checkout-table-column-px300 text-right">
                        <h4 class="mb-0">
                          <template v-if="$currencyCode == 'USD'">
                            Sales Tax<template v-if="taxIncludedInPrice"> (included)</template>:
                          </template>
                          <template v-else>
                            VAT<template v-if="taxIncludedInPrice"> (included)</template>:
                          </template>
                        </h4>
                      </div>
                    </template>
                    <template v-else>
                      <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                      <div class="checkout-table-column checkout-table-column-px380"></div>
                      <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                      <div class="checkout-table-column text-right" style="max-width: 600px;">
                        <h4 class="mb-0">
                          <template v-if="$currencyCode == 'USD'">
                            Sales Tax<template v-if="taxIncludedInPrice"> (included)</template>:
                          </template>
                          <template v-else>
                            VAT<template v-if="taxIncludedInPrice"> (included)</template>:
                          </template>
                        </h4>
                      </div>
                    </template>

                    <template v-if="$mq != 'xs'">
                      <div class="checkout-table-column checkout-table-column-px100" :class="$mq == 'sm' ? 'text-right' : ''">
                        <h4 v-if="cartOrSale =='cart'" class="mb-0" style="letter-spacing: 0;">{{ cart.priceVat | money}}</h4>
                        <h4 v-if="cartOrSale =='sale'" class="mb-0" style="letter-spacing: 0;">{{ sale.totalAmountVat | money}}</h4>
                      </div>
                    </template>
                  </div>

                  <div class="checkout-table-row">
                    <template v-if="$mq == 'xs'">
                      <div class="checkout-table-column">
                        <h4 class="mb-0 font-weight-bold" style="letter-spacing: 0;">
                          TOTAL:
                          <template v-if="cartOrSale == 'cart'">{{ cart.priceIncVat - discountedAmount | money}}</template>
                          <template v-if="cartOrSale == 'sale'">{{ sale.subtotal_amount | money}}</template>
                        </h4>
                      </div>
                    </template>
                    <template v-else-if="$mq == 'sm'">
                      <div class="checkout-table-column checkout-table-column-px140"></div>
                      <div class="checkout-table-column checkout-table-column-px300 text-right">
                        <h4 class="mb-0 font-weight-bold">TOTAL:</h4>
                      </div>
                    </template>
                    <template v-else>
                      <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                      <div class="checkout-table-column checkout-table-column-px380"></div>
                      <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                      <div class="checkout-table-column text-right" style="max-width: 600px;">
                        <h4 class="mb-0 font-weight-bold">TOTAL:</h4>
                      </div>
                    </template>

                    <template v-if="$mq != 'xs'">
                      <div class="checkout-table-column checkout-table-column-px100" :class="$mq == 'sm' ? 'text-right' : ''">
                        <h4 v-if="cartOrSale =='cart'" class="mb-0 font-weight-bold" style="letter-spacing: 0;">{{ cart.priceIncVat - discountedAmount | money}}</h4>
                        <h4 v-if="cartOrSale =='sale'" class="mb-0 font-weight-bold" style="letter-spacing: 0;">{{ sale.total_amount | money}}</h4>
                      </div>
                    </template>
                  </div>

                </div>

              </template> <!-- /FOOTER -->

              <div class="checkout-table-body text-tempus-blue-tint" v-if="vouchersToSpend.length" ref="voucherCheckout">
                <div class="checkout-table-row" v-for="voucher in vouchersToSpend">
                  <template v-if="($mq == 'xs' || $mq == 'sm')">
                    <div class="checkout-table-column checkout-table-column-px140"></div>
                    <div class="checkout-table-column checkout-table-column-px300 text-right">
                      <h4>
                        <button class="btn btn-sm btn-red" @click="removeVoucher(voucher)"><span class="material-icons">delete</span></button> {{ voucher.reference }} Voucher Amount:
                      </h4>
                    </div>
                  </template>
                  <template v-else>
                    <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                    <div class="checkout-table-column checkout-table-column-px380"></div>
                    <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                    <div class="checkout-table-column text-right" style="max-width: 600px;">
                      <h4 class="mb-0" :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''">
                        <button class="btn btn-sm btn-red" @click="removeVoucher(voucher)"><span class="material-icons">delete</span></button> {{ voucher.reference }} Voucher Amount:
                      </h4>
                    </div>
                  </template>
                  <div class="checkout-table-column checkout-table-column-px100 font-weight-bold">
                    <h4 class="mb-0 text-red" :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''">{{ -voucher.cashValue | money }}</h4>
                  </div>
                </div>
                <div class="checkout-table-row">
                  <template v-if="($mq == 'xs' || $mq == 'sm')">
                    <div class="checkout-table-column checkout-table-column-px140"></div>
                    <div class="checkout-table-column checkout-table-column-px300 text-right" :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''">
                      Left To Pay After <template v-if="vouchersToSpend.length > 2">{{ vouchersToSpend.length }} Redemptions</template><template v-else>Redemption:</template>
                    </div>
                  </template>
                  <template v-else>
                    <div class="checkout-table-column checkout-table-column-px100 text-center"></div>
                    <div class="checkout-table-column checkout-table-column-px380"></div>
                    <div class="checkout-table-column" :class="locationChildPricing ? 'checkout-table-column-px240' : 'checkout-table-column-px160'"></div>
                    <div class="checkout-table-column" style="max-width: 600px;">
                      <h4 class="font-weight-bold mb-0" :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''">
                        Left To Pay After <template v-if="vouchersToSpend.length > 2">{{ vouchersToSpend.length }} Redemptions</template><template v-else>Redemption:</template></h4>
                      </h4>
                    </div>
                  </template>
                  <div class="checkout-table-column checkout-table-column-px100 font-weight-bold text-white">
                    <h4 class="font-weight-bold mb-0" v-if="cartOrSale == 'cart'">{{ discountedTotal - totalOfVoucherRedemption | money }}</h4>
                    <h4 class="font-weight-bold mb-0" v-else-if="cartOrSale == 'sale'">{{ sale.left_to_pay - totalOfVoucherRedemption | money }}</h4>
                  </div>
                </div>
              </div>

            </div> <!-- .checkout-table .checkout-table-dark -->

            <div v-if="products && products.length" class="alert alert-tempus-blue">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="font-weight-bold">Add-ons</h4>
                  <p>Extras for your experience&hellip;</p>
                </div>

                <div class="checkboxdiv">
                  <label :for="$id('showLocationAddOns')" class="mr-2">Show Add-Ons?</label>
                  <label class="checkboxdiv-label-lg">
                    <input type="checkbox" :id="$id('showLocationAddOns')" v-model="showLocationAddOns">
                    <span class="cr"><span class="cr-icon">&#10004;</span></span>
                  </label>
                </div>

                <div class="checkboxdiv">
                  <!-- TODO: refactor to actually work-->
                  <!-- <label :for="$id('showRoomAddOns')" class="mr-2">Show Room Add-Ons Here?</label>
                  <label class="checkboxdiv-label-lg">
                    <input type="checkbox" :id="$id('showRoomAddOns')" v-model="showRoomAddOns">
                    <span class="cr"><span class="cr-icon">&#10004;</span></span>
                  </label> -->
                </div>

                <div>
                  <div class="btn-group flex-wrap float-right">
                    <button
                      @click="displayAddOnsAsList = true"
                      data-toggle="tooltip"
                      title="Show Add-Ons As List"
                      class="btn btn-tempus-blue material-icons"
                      :class="displayAddOnsAsList ? 'active' : ''">dns</button>
                    <button
                      @click="displayAddOnsAsList = false"
                      data-toggle="tooltip"
                      title="Show Add-Ons As Card Grid"
                      class="btn btn-tempus-blue material-icons"
                      :class="displayAddOnsAsList ? '' : 'active'">grid_view</button>
                  </div>
                </div>
              </div>

              <template v-if="showLocationAddOns">
                <template v-if="displayAddOnsAsList">
                  <table class="table table-striped table-dark">
                    <thead>
                      <tr>
                        <template v-if="($mq == 'xs' || $mq == 'sm')">
                          <th class="pl-1">Item</th>
                        </template>
                        <template v-else>
                          <th class="pl-3"><span class="material-icons" style="position: relative; top: 6px;">construction</span></th>
                          <th class="pl-1" colspan="2">Item</th>
                        </template>
                        <th class="pl-1" :style="locationChildPricing ? 'width: 230px;' : ''">Qty</th>
                        <th class="pl-1">Details</th>
                        <th class="pl-1">Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="addOn in visibleAddOns" :key="addOn.id">
                        <template v-if="($mq == 'xs' || $mq == 'sm')">
                          <td class="p-1" style="vertical-align: middle;">
                            <div class="pb-2"> <!-- TOOLS -->
                              <button class="btn btn-dark-green" @click="addProduct(addOn)"><span class="material-icons">add_shopping_cart</span></button>
                            </div> <!-- /TOOLS -->

                            <div class="row"> <!-- ITEM -->
                              <div class="col">
                                <img :alt="addOn.name" :src="addOn.imageUrl ? addOn.imageUrl : '/img/sale/product.jpg'" width="100" class="mr-2">
                              </div>
                            </div> <!-- /ITEM -->

                            <div class="row">
                              <div class="col">
                                <p class="text-shadow-highlight mb-1 font-weight-bold text-tempus-blue mb-0">{{ addOn.name }}</p>
                              </div>
                            </div>
                          </td> <!-- /ITEM -->
                        </template>

                        <template v-else> <!-- ! ($mq == 'xs' || $mq == 'sm') -->
                          <td class="p-1" style="vertical-align: middle;"> <!-- TOOLS -->
                            <button class="btn btn-dark-green" @click="addProduct(addOn)"><span class="material-icons">add_shopping_cart</span></button>
                          </td>
                          <td class="p-1" style="vertical-align: middle;">
                            <img :alt="addOn.name" :src="addOn.imageUrl ? addOn.imageUrl : '/img/sale/product.jpg'" width="100" class="mr-2">
                          </td> <!-- /TOOLS -->
                          <td class="p-1" style="vertical-align: middle;"> <!-- ITEM -->
                            <p class="text-shadow-highlight mb-1 font-weight-bold text-tempus-blue-tint">{{ addOn.name }}</p>
                          </td> <!-- /ITEM -->
                        </template>

                        <td class="p-1" style="vertical-align: middle;"> <!-- QTY -->
                          <p class="mb-0">1</p>
                        </td> <!-- /QTY -->

                        <td class="p-1" style="vertical-align: middle;"> <!-- DETAILS -->
                          <p class="mb-0">{{ addOn.description }}</p>
                          <p
                            v-if="addOn.for_room"
                            class="mb-0"
                            :class="'text-' + addOn.for_room.nickname"
                            style="font-size: 11px; line-height: 11px">
                            Add-on for {{ addOn.for_room.name }}
                          </p>
                          <p
                            v-if="addOn.options && addOn.options.caveat"
                            v-html="addOn.options.caveat"
                            class="text-pink mt-2"
                            style="font-size: 11px; line-height: 11px">
                          </p>
                        </td> <!-- DETAILS -->

                        <td class="p-1" style="vertical-align: middle;"> <!-- PRICE -->
                          <button class="btn btn-block btn-dark-green" @click="addProduct(addOn)"><span class="material-icons">add_shopping_cart</span> Add to cart for {{ addOn.sale_price | money }}
                          </button>
                        </td> <!-- /PRICE -->
                      </tr>
                    </tbody>
                  </table> <!-- /showLocationAddOns -->
                </template> <!-- /displayAddOnsAsList -->
                <template v-else> <!-- ! displayAddOnsAsList -->
                  <div class="row row-cols-2 row-cols-md-4 row-cols-lg-6">
                    <div class="col mb-4" v-for="addOn in visibleAddOns">
                      <div class="card text-white bg-tempus-blue">
                        <img :alt="addOn.name" :src="addOn.imageUrl ? addOn.imageUrl : '/img/sale/product.jpg'" class="card-img-top">
                        <div class="card-body">
                          <h4 class="font-weight-bold my-1">{{ addOn.name }}</h4>
                          <p class="font-italic">{{ addOn.description }}</p>
                          <p
                            v-if="addOn.for_room"
                            class="mb-0"
                            :class="'text-' + addOn.for_room.nickname"
                            style="font-size: 11px; line-height: 11px">
                            Add-on for {{ addOn.for_room.name }}
                          </p>
                          <p
                            v-if="addOn.options && addOn.options.caveat"
                            v-html="addOn.options.caveat"
                            class="text-pink mt-2"
                            style="font-size: 11px; line-height: 11px">
                          </p>
                        </div>
                        <div class="card-footer">
                          <button class="btn btn-block btn-dark-green">
                            Add for {{ addOn.sale_price | money }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template> <!-- /! displayAddOnsAsList -->
              </template>
            </div> <!-- /v-if products.length -->

            <div class="alert alert-yellow" v-show="showDiscountSection" ref="discountSection" id="discountSection">
              <div class="row">
                <div class="col-sm-5">
                  <div class="alert alert-success" role="alert">
                    <h5 v-if="cartOrSale == 'cart'">
                      Pre-Discount Cost:
                      <strong>{{ cart.price | money }}</strong>
                      <small v-if="inPromo" class="text-red"> inc. {{ locationDiscount.percentage}}% discount</small>
                    </h5>
                    <h5 v-else-if="cartOrSale == 'sale'">
                      Pre-Discount Cost:
                      <strong>{{ sale.subtotal_amount | money }}</strong>
                      <small v-if="inPromo" class="text-red"> inc. {{ locationDiscount.percentage}}% discount</small>
                    </h5>

                    <h4 v-if="discountedAmount">Discounted Amount:
                      <strong class="text-red">-{{ discountedAmount | money }}</strong>
                    </h4>

                    <h4>Discounted Total:
                      <strong>{{ discountedTotal | money }}</strong>
                    </h4>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="alert alert-primary text-center" role="alert" style="padding-top: 6px; padding-bottom: 6px;">
                    <div class="input-group">
                      <input
                        type="text"
                        ref="discountCode"
                        class="form-control"
                        placeholder="Discount Code"
                        v-model="discountCode">
                      <div class="input-group-append">
                        <button class="btn btn-orange" type="button" ref="submitDiscountCodeButton" @click="submitDiscountCode" :disabled="! discountCode">Redeem</button>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col">
                        <button class="btn btn-lg btn-block btn-secondary" v-if="! discount" @click="cancelRedeeming">Cancel Discounting</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1">
                  <button type="button" class="close" @click="showDiscountSection = false; discountButtonDisable = false;"><span aria-hidden="true">&times;</span></button>
                </div>
              </div>
              <div class="row" v-if="discountingError">
                <div class="col">
                  <div class="alert alert-danger" role="alert">
                    <div class="input-group">
                      <p class="mb-0">{{ discountingError }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="discountingSuccess">
                <div class="col">
                  <div class="alert alert-orange" role="alert">
                    <div class="input-group">
                      <template v-if="discount && discount.options && discount.options.booking_to">
                        <p class="mb-0">Discount applied to applicable item(s) in Cart: {{ discount.style }}</p>
                      </template>
                      <template v-else>
                        <p class="mb-0">Discount applied to Cart: {{ discount.style }}</p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div> <!-- showDiscountSection -->

            <div class="alert alert-yellow" v-show="showVoucherSection" ref="voucherSection">
              <div class="row">
                <div class="col-sm-5">
                  <div class="alert alert-success" role="alert">
                    <div class="input-group input-group-lg" v-if="cartOrSale == 'cart'">
                      <h4>
                        <h5 :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''" class="mb-0">Total Cost: <strong>{{ discountedTotal | money }}</strong></h5>
                        <h5 v-if="discountedAmount" class="mb-0" :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''"><small class="text-red"> inc. {{ discountedAmount | money }} discount</small></h5>
                        <h4 :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''" class="mt-2 mb-0">Left To Pay: <strong>{{ discountedTotal - totalOfVoucherRedemption | money }}</strong></h4>
                      </h4>
                    </div>
                    <div class="input-group input-group-lg" v-else>
                      <h4>
                        <h5 :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''" class="mb-0">Total Cost: <strong>{{ discountedTotal | money }}</strong></h5>
                        <h5 v-if="discountedAmount" class="mb-0" :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''"><small class="text-red"> inc. {{ discountedAmount | money }} discount</small></h5>
                        <h4 :style="$deploymentIs('breakescape') ? 'letter-spacing: 0;' : ''" class="mt-2 mb-0">Left To Pay: <strong>{{ sale.left_to_pay - totalOfVoucherRedemption | money }}</strong></h4>
                      </h4>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="alert alert-primary text-center" role="alert" style="padding-top: 6px; padding-bottom: 6px;">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Voucher Code"
                        ref="voucherCode"
                        v-model="voucherCode">
                      <div class="input-group-append">
                        <button class="btn btn-orange" type="button" ref="submitVoucherCodeButton" @click="submitVoucherCode" :disabled="! voucherCode">Redeem</button>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col">
                        <button class="btn btn-lg btn-block btn-secondary" v-if="! discount" @click="cancelRedeeming('VOUCHER')">Cancel Redeeming</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1">
                  <button type="button" class="close" @click="showVoucherSection = false; voucherButtonDisable = false;"><span aria-hidden="true">&times;</span></button>
                </div>
              </div>
              <div class="row" v-if="voucherError">
                <div class="col">
                  <div class="alert alert-danger" role="alert">
                    <div class="input-group">
                      <p class="mb-0">{{ voucherError }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div> <!-- showVoucherSection -->

            <div class="alert alert-white" v-if="location.location_questions.length">
              <template v-if="locationQuestionsMinimised">
                <div class="d-flex justify-content-between">
                  <h4 class="font-weight-bold text-tempus-blue">Location Questions Minimised</h4>
                  <button class="btn btn-tempus-blue float-right" @click="expandLocationQuestions" data-toggle="tooltip" title="Click to expand this section"><span class="material-icons">expand</span></button>
                </div>
              </template>
              <template v-else>
                <button type="button" class="close" @click="locationQuestionsMinimised = true">
                  <span>&times;</span>
                </button>

                <p>When you click <span class="text-green font-weight-bold">PAY</span> the Room slots will be reserved for you for {{ roomSlotLockLength }} minutes to complete the transaction. Please complete the payment within this time.</p>

                <template v-if="cartOrSale !== null && location.location_questions.length">
                  <template v-if="cartOrSale == 'cart'">
                    <location-questions-response-crud
                      v-model="cart.cart_question_responses"
                      :location-questions="location.location_questions"
                      :cart="cart"></location-questions-response-crud>
                  </template>
                  <template v-else>
                    <location-questions-response-crud
                      v-model="sale.sale_question_responses"
                      :location-questions="location.location_questions"
                      :sale="sale"></location-questions-response-crud>
                  </template>
                </template>
              </template>

              <div v-if="locationQuestionsError" class="">
                <h4 class="font-italic font-weight-bold text-red">{{ locationQuestionsError }}</h4>
              </div>

              <div v-if="checkoutError" class="">
                <h4 class="font-italic font-weight-bold text-red">{{ checkoutError }}</h4>
              </div>
            </div>

            <div class="d-flex justify-content-between flex-wrap">
              <div class="pb-4 order-1">
                <div class="btn-group" role="group">
                  <button type="button"
                    class="btn btn-tempus-blue-300"
                    @click="discountButtonClicked"
                    :disabled="discountButtonDisable || disablePayButton"
                    >Use Discount Code <span class="material-icons" style="position: relative; top: 5px;">discount</span></button>
                  <button
                    v-if="featureVoucher"
                    type="button"
                    class="btn btn-tempus-blue-600"
                    @click="voucherButtonClicked"
                    :disabled="voucherButtonDisable || disablePayButton"
                    >Spend Voucher <span class="material-icons" style="position: relative; top: 5px;">local_activity</span></button>
                </div>
              </div>

              <div class="pb-4 order-2" v-if="cartOrSale == 'cart' && cart.cart_items.length && fromIframe">
                <button
                  id="emptyCart"
                  class="btn btn-lg btn-red"
                  @click="cartEmptyConfirmation">
                  Empty Cart <span class="material-icons" style="position: relative; top: 5px;">remove_shopping_cart</span>
                </button>
              </div>

              <div v-if="(roomQuestionsRequired != 0 && (roomQuestionsRequired != requiredRoomQuestionsAnswered)) || ((locationQuestionsRequired.length != 0) && (locationQuestionsRequired.length != requiredLocationQuestionsAnswered.length))" class="pb-4 order-3">
                <table class="table table-dark table-striped table-striped bg-dark-red">
                  <thead>
                    <tr>
                      <th>Questions</th>
                      <th>Required</th>
                      <th>Answered</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="roomQuestionsRequired > requiredRoomQuestionsAnswered">
                      <th>Room</th>
                      <td>{{ roomQuestionsRequired }}</td>
                      <td class="text-yellow">{{ requiredRoomQuestionsAnswered }}</td>
                    </tr>
                    <tr v-if="locationQuestionsRequired.length > requiredLocationQuestionsAnswered.length">
                      <th>Location</th>
                      <td>{{ locationQuestionsRequired.length }}</td>
                      <td class="text-yellow">{{ requiredLocationQuestionsAnswered.length }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="pb-4 order-4">
                <template v-if="cartOrSale == 'cart'">
                  <div class="btn-group">
                    <button
                      v-if="cart.price == discountedAmount"
                      class="btn btn-lg btn-dark-green"
                      @click="takePaymentCart">
                      Complete Discounted Sale <span class="material-icons" style="position: relative; top: 5px;">discount</span>
                    </button>
                    <button
                      v-else-if="depositable"
                      class="btn btn-lg btn-orange"
                      @click="takePaymentCart(true)">
                      PAY {{ defaultPerRoomDeposit | money }} PER ROOM DEPOSIT ({{ depositAmount | money }}) <span class="material-icons" style="position: relative; top: 5px;">payment</span>
                    </button>
                    <button
                      v-else
                      class="btn btn-lg btn-dark-green"
                      :disabled="disablePayButton || noCustomerOnCart"
                      @click="takePaymentCart">
                      Pay For Cart <span class="material-icons" style="position: relative; top: 5px;">payment</span>
                    </button>
                    <button
                      v-if="noCustomerOnCart"
                      class="btn btn-lg btn-purple"
                      @click="getCustomerDetails">
                      Add My Details <span class="material-icons" style="position: relative; top: 5px;">manage_accounts</span>
                    </button>
                    <p v-if="noCustomerOnCart" class="text-orange font-weight-bold d-block">There is no customer attached to this Cart, please click <span class="badge badge-purple p-2">Add My Details</span></p>
                  </div>
                </template>
                <template v-else>
                  <div class="btn-group">
                    <button
                      v-if="depositable && sale.deposit_amount && sale.deposit_amount != sale.total_amount"
                      class="btn btn-lg btn-dark-orange"
                      @click="takePaymentSale(false, true)">
                      PAY {{ sale.deposit_amount | money }} DEPOSIT
                    </button>
                    <button
                      v-else-if="depositable && ! sale.deposit_amount"
                      class="btn btn-lg btn-dark-orange"
                      @click="takePaymentSale(false, true)">
                      PAY {{ defaultPerRoomDeposit | money }} PER ROOM DEPOSIT <span v-if="">({{ depositAmount | money }})</span>
                    </button>
                    <button
                      v-if="featureVoucher && totalOfVoucherRedemption == sale.total_amount"
                      class="btn btn-lg btn-dark-green"
                      @click="takePaymentSale(true)">
                      Redeem Voucher On Sale
                    </button>
                    <button
                      v-else-if="sale.totalTransactionsAmount"
                      class="btn btn-lg btn-dark-green"
                      :disabled="disablePayButton || (saleInProgress && saleNotInRecovery)"
                      @click="takePaymentSale(false)">
                      Pay Remaining
                    </button>
                    <button
                      v-else
                      class="btn btn-lg btn-dark-green"
                      :disabled="disablePayButton || (saleInProgress && saleNotInRecovery)"
                      @click="takePaymentSale(false)">
                      Pay In Full
                    </button>
                  </div>
                </template>
              </div>

              <p v-if="! fromIframe && disablePayButton" class=" mx-2 text-red font-italic">
                Your cart has been sent to be paid and has been emptied, please complete the payment in the opened window. If you close the window, choose one of the slots on the Booking Calendar or click Retry Sale Payment.
              </p>
              <div v-if="! fromIframe && disablePayButton">
                <a :href="saleUrl" class="btn btn-lg btn-purple float-right">Retry Sale Payment</a>
              </div>
            </div> <!-- .justify-content-between -->
          </div>

          <div v-if="! fromIframe" class="col-xl-2 mb-2" :class="($mq == 'lg' || $mq == 'md' || $mq == 'sm' || $mq == 'xs') ? 'order-1' : ''" ref="customerPane">
            <table class="table table-striped table-light" style="table-layout:fixed; width:99%;">
              <thead class="thead-dark">
                <tr>
                  <th>Customer Details <button type="button" class="btn btn-sm btn-sandstone float-right" @click="editingCustomer = ! editingCustomer"><span class="material-icons">edit</span></button></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Email:</th>
                </tr>
                <tr>
                  <td v-if="editingCustomer && false"><input class="form-control form-control-sm" v-model="customer.email"></td>
                  <td v-else style="overflow: hidden;">{{ customer.email }}</td>
                </tr>
                <tr v-if="editingCustomer">
                  <td class="text-red" style="overflow: hidden; font-size: 80%;">You cannot edit your email address here. If you have inputted your email incorrectly, <template v-if="cartOrSale == 'cart'">empty cart, and start again.</template><template v-else> contact us.</template></td>
                </tr>
                <tr>
                  <th>Name:</th>
                </tr>
                <tr>
                  <td v-if="editingCustomer"><input class="form-control form-control-sm" v-model="customer.name"></td>
                  <td v-else>{{ customer.name }}</td>
                </tr>

                <tr v-if="customerRequestMarketingPermission">
                  <th>
                    <label :for="$id('marketing_consent')">Marketing Consent:</label>
                    <div class="checkboxdiv ml-2" style="display: inline-block; position: relative; top: 16px;">
                      <label class="checkboxdiv-label-md">
                        <input
                          :disabled="! editingCustomer"
                          type="checkbox"
                          :id="$id('marketing_consent')"
                          v-model="marketingConsent">
                        <span class="cr"><span class="cr-icon">&#10004;</span></span>
                      </label>
                    </div>
                  </th>

                </tr>
                <tr v-else>

                </tr>
              </tbody>
            </table>

            <div v-if="editingCustomer" class="mr-2 mb-2">
              <button
                class="btn btn-lg btn-dark-green"
                @click="updateCustomer">
                Update Details
              </button>
            </div>

            <button
              v-if="cartOrSale == 'cart'"
              id="emptyCart"
              class="btn btn-lg btn-red"
              @click="cartEmptyConfirmation">
              Empty Cart <span class="material-icons" style="position: relative; top: 5px;">remove_shopping_cart</span>
            </button>
            <button
              v-else-if="saleDeletable"
              id="emptySale"
              class="btn btn-lg btn-red"
              @click="saleEmptyConfirmation">
              Cancel Sale
            </button>
          </div>

        </div> <!-- .row -->
      </div>
    </template>
    <template v-else> <!-- v-if="sortedItems.length"  -->
      <div class="container">
        <div class="row">
          <div class="col">
            <h1 class="font-weight-bold mt-4">Your Cart Is Empty!</h1>
            <div class="alert alert-yellow">
              <h2 class="font-weight-bold">Add Products To Your Cart</h2>
              <p>Please navigate to the booking page(s) and you can add multiple slots into your basket.</p>
              <p>When you checkout, you can confirm the items in your cart here. You can then pay for all items with one transaction.</p>
            </div>
            <div class="alert alert-red">
              <span class="material-icons md-72 text-red">info</span> &hellip;if you are experiencing any problems, please <a :href="contactRoute" class="btn btn-purple">Contact Us</a>
            </div>
          </div>
        </div>
      </div> <!-- .container -->
    </template>

    <pay-handler
      v-if="! fromIframe"
      ref="payComponent"
      :location="location"/>

  </div>
</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    consoleDebug: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      required: true,
    },
    initialCart: {
      type: Object,
    },
    initialSale: {
      type: Object,
    },
    locationDiscount: {
      type: Object,
      required: false,
    },
    locationChildPricing: {
      type: Boolean,
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
    customerRequestMarketingPermission: {
      type: Boolean,
    },
    roomSlotLockLength: {
      type: Number,
      default: 15,
    },
    featureVoucher: {
      type: Boolean,
    },
    bookingFee: {
      type: Number,
      default: 0,
    },
    defaultPerRoomDeposit: {
      type: Number,
      default: 5000,
    },
    products: {
      type: Array,
    },
    roomProducts: {
      type: Array,
    },
    fromIframe: {
      type: Boolean,
      default: false,
    },
    saleInProgress: {
      type: Boolean,
      default: false,
    },
    saleNotInRecovery: {
      type: Boolean,
      default: true,
    },
    allowZeroAdults: {
      type: Boolean,
      default: false,
    },
    checkoutError: {
      default: false,
    },
    taxIncludedInPrice: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      cart: Vue.util.extend({}, this.initialCart ? JSON.parse(JSON.stringify(this.initialCart)) : {}),
      sale: Vue.util.extend({}, this.initialSale ? JSON.parse(JSON.stringify(this.initialSale)) : {}),

      discountButtonDisable: false,
      voucherButtonDisable: false,
      showDiscountSection: false,
      showVoucherSection: false,

      discountCode: null,
      discount: (! this.fromIframe && this.initialCart) ? (this.initialCart.discounts.length ? this.initialCart.discounts[0] : null) : ((! this.fromIframe && this.initialSale.discounts.length) ? this.initialSale.discounts[0] : null),
      discountingError: false,
      discountingSuccess: false,

      vouchersToSpend: [],
      voucherCode: null,
      voucherError: false,

      temporaryCart: null,
      disableCartEchoUpdateFlag: false,
      disablePayButton: false,

      editingCustomer: false,
      customer: this.initialCart ? (this.initialCart.customer ? Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialCart.customer))) : {
        email: null,
        name: null,
      }) : Vue.util.extend({}, JSON.parse(JSON.stringify(this.initialSale.customer))),
      marketingConsent: false,

      locationQuestionsError: null,
      locationQuestionsMinimised: false,
      locationQuestionsMinimisedPressed: false,

      showLocationAddOns: true,
      showRoomAddOns: false,
      displayAddOnsAsList: true,
    };
  },

  computed: {
    cartOrSale() {
      if (Object.keys(this.cart).length && ! Object.keys(this.sale).length) {
        return 'cart';
      } else if (Object.keys(this.sale).length) {
        return 'sale';
      }
      return null;
    },

    noCustomerOnCart() {
      if (this.cartOrSale == 'cart') {
        if (this.cart.customer) {
          return false;
        }
        return true;
      }
      return false;
    },

    displayCheckout() {
      if (this.sortedItems.length) {
        if (this.cartOrSale == 'cart') {
          return true;
        }
        if (this.fromPbl) {
          return true;
        }
        if (this.sale.transactions.length > 0 && this.sale.left_to_pay == 0) {
          return false;
        }
      }
      if (this.cartOrSale == 'cart') {
        return false;
      }
      return true;
    },

    inPromo() {
      if (this.locationDiscount) {
        if (moment().isBetween(moment(this.locationDiscount.valid_from), moment(this.locationDiscount.expiry))) {
          return true;
        }
      }
      return false;
    },

    isDiscounted() {
      // inPromo should only apply to Carts, as as soon as a LocationDiscount is used on a Cart, it is added as a Discount to the Sale
      if (this.cartOrSale == 'cart') {
        if (this.cart.discountDetails && this.cart.discountDetails.amount && this.cart.discountDetails.amount > 0) {
          return true;
        }
        if (this.inPromo) {
          return true;
        }
      } else if (this.cartOrSale == 'sale') {
        if (this.sale.discountedAmount) {
          return true;
        } else if (this.sale.discounts.length) {
          return true;
        }
      }
      return false;
    },

    discountedAmount() {
      if (this.cartOrSale == 'sale') {
        return parseInt(this.sale.discountedAmount);
      }

      if (this.inPromo) {
        return parseInt(this.cart.price * (this.locationDiscount.percentage / 100));
      }
      if (this.isDiscounted) {
        return parseInt(this.cart.discountDetails.amount);
      }
      return 0;
    },

    discountedTotal() {
      if (this.cartOrSale == 'cart') {
        return parseInt(this.cart.price - this.discountedAmount);
      }
      return parseInt(this.sale.total_amount);
    },

    discountDescription() {
      if (this.isDiscounted) {
        if (this.cartOrSale == 'cart'
          && this.cart.discountDetails
          && this.cart.discountDetails.amount
          && this.cart.discountDetails.amount > 0) {
          return this.cart.discountDetails.description;
        } else if ((this.cartOrSale == 'sale' && this.sale.discount_description)
          || (this.cartOrSale == 'sale' && this.sale.discounts.length)) {
          return this.sale.discount_description ? this.sale.discount_description : this.sale.discounts[0].description;
        } else if (this.locationDiscount) {
          return this.locationDiscount.description;
        }
      }
      return null;
    },

    totalOfVoucherRedemption() {
      if (this.vouchersToSpend.length) {
        return parseInt(this.vouchersToSpend.reduce((partialSum, v) => partialSum + v.cashValue, 0));
      }
      return 0;
    },

    fromPbl() {
      if (this.cartOrSale == 'cart') {
        return false;
      }
      return this.sale.options && this.sale.options.pbl_expiry;
    },

    saleDeletable() {
      if (this.cartOrSale == 'cart') {
        // nonsense!
        return false;
      } else if (this.sale.transactions.length > 0) {
        return false;
      } else if (this.fromPbl) {
        return false;
      }

      return true;
    },

    depositable() {
      if (this.cartOrSale === null) {
        return false;
      }
      if (this.cartOrSale == 'cart') {
        return false;
      }
      // the rules for this are as follows

      if (this.sale.transactions && this.sale.transactions.length == 0) {
        // is it from a PBL?
        if (this.fromPbl) {
          return true;
          // use the deposit amount that is set
          // if deposit amount is null, use the Meta default
        }

        // if the default depositable amount is very close to the full amount, don't let it happen
        if (this.sale.total_amount * 0.8 < this.depositAmount) {
          return false;
        }

        // this SaleCheckout, if not a PBL, can only be got to via the unlocking of a previous attempt
        // usually this happens from a failed amount, so a deposit is offered
        // this now has a Meta|Option setting
        return this.allowRetryDeposit;
      }

      if (this.sale.totalTransactionsAmount == 0) {
        // to allow for an accidental FOC or a PayOnArrival
        return true;
      }

      // there is already at least 1 transaction, do not allow a deposit
      return false;
    },

    discountable() {
      if (! this.inPromo && this.discountedAmount) {
        return false;
      }

      if (this.cartOrSale == 'sale' && this.sale.totalTransactionsAmount) {
        return false;
      }

      return true;
    },

    // discountDescription() {
    //   if (this.discount) {
    //     return this.discount.description;
    //   }

    //   return this.sale.discount_description;
    // },

    depositAmount() {
      if (this.cartOrSale == 'cart') {
        return 99999;
      }
      if (this.sale.deposit_amount) {
        return this.sale.deposit_amount;
      }
      return this.sale.sale_items.filter(si => si.saleable_type == 'App\\Models\\Booking').length * this.defaultPerRoomDeposit;
    },

    headerClass() {
      var theClass = '';
      switch (this.$deploymentCurrent) {
        case 'cryptology':
        case 'm4escapes':
        theClass = 'bg-lt-maze text-black';
          break;

        case 'taketheexit':
        theClass = 'mt-4';
          break;

        case 'breakescape':
        theClass = 'tempus-iframe-800-container';

        default:
          break;
      }

      return theClass;
    },

    contactRoute() {
      return this.location.locationContactHref;
    },

    roomQuestions() {
      return this.location.rooms.filter(r => r.room_questions.length)
        .reduce((map, obj) => {
          map[obj.id] = obj.room_questions;

          return map;
        }, {});
    },

    roomsPresent() {
      if (this.cartOrSale === null) {
        return [];
      }
      if (this.cartOrSale == 'cart') {
        return this.cart.cart_items.filter(ci => ci.cartable_type == 'App\\Models\\RoomSlot').map(ci => ci.cartable.room_id);
      }

      return this.sale.sale_items.filter(si => si.cartable_type == 'App\\Models\\Booking').map(si => si.saleable.room_slot.room_id);
    },

    roomQuestionsRequired() {
      var num = 0;
      this.roomsPresent.forEach(room_id => {
        if (this.roomQuestions[room_id]) {
          num += this.roomQuestions[room_id].filter(rq => rq.required).length;
        }
      });
      return num;
    },

    requiredRoomQuestionsAnswered() {
      if (this.cartOrSale == null) {
        return 0;
      }
      var num = 0;
      if (this.cartOrSale == 'cart') {
        this.cart.cart_items.forEach(ci => {
          if (ci.cart_item_question_responses) {
            num += ci.cart_item_question_responses.filter(ciqr => ciqr.questionable.required && (ciqr.response != null && ciqr.response != 0 && ciqr.response != '')).length;
          }
        });
      } else {
        this.sale.sale_items.forEach(si => {
          if (si.cart_item_question_responses) {
            num += si.sale_item_question_responses.filter(siqr => siqr.questionable.required && (siqr.response != null && siqr.response != 0 && siqr.response != '')).length;
          }
        });
      }

      return num;
    },

    locationQuestionsRequired() {
      return this.location.location_questions.filter(lq => lq.required);
    },

    requiredLocationQuestionsAnswered() {
      if (this.cartOrSale === null) {
        return true;
      }
      if (this.cartOrSale == 'cart') {
        return this.cart.cart_question_responses.filter(cqr => cqr.questionable.required).filter(cqr => {
          if (cqr.questionable.type == 'CHECKBOX') {
            if (cqr.response == 0 || cqr.response === null) {
              return false;
            } else {
              return true;
            }
          } else if (cqr.questionable.type == 'RADIO' && cqr.response === null) {
            return false;
          } else if (cqr.response == '' || cqr.response == null) {
            return false;
          }
          return true;
        });
      } else {
        return this.sale.sale_question_responses.filter(sqr => sqr.questionable.required).filter(sqr => {
          if (sqr.questionable.type == 'CHECKBOX') {
            if (sqr.response == 0 || sqr.response === null) {
              return false;
            } else {
              return true;
            }
          } else if (sqr.questionable.type == 'RADIO' && sqr.response === null) {
            return false;
          } else if (sqr.response == '' || sqr.response == null) {
            return false;
          }
          return true;
        });
      }
    },

    sortedItems() {
      if (this.cartOrSale === null) {
        return [];
      }

      if (this.cartOrSale == 'cart') {
        if (this.cart.cart_items.length) {
          // we want the RoomSlots always at the top, so let's sort these first
          let sortedRoomSlotItems = this.cart.cart_items
            .filter(ci => ci.cartable_type == 'App\\Models\\RoomSlot')
            .sort((a, b) => moment(a.cartable.start) - moment(b.cartable.start));

          let otherItems = this.cart.cart_items
            .filter(ci => ci.cartable_type != 'App\\Models\\RoomSlot' && ci.cartable_type != 'App\\Models\\Product');

          let addOnItems = this.cart.cart_items
            .filter(ci =>
              ci.cartable_type == 'App\\Models\\Product'
              && (ci.options == null || typeof(ci.options.for_room_slot_ids) == 'undefined')
            );

          return [...sortedRoomSlotItems, ...otherItems, ...addOnItems];
        }
      } else {
        if (this.sale.sale_items.length) {
          // we want the RoomSlots always at the top, so let's sort these first
          let sortedRoomSlotItems = this.sale.sale_items
            .filter(si => si.saleable_type == 'App\\Models\\Booking')
            .sort((a, b) => moment(a.saleable.room_slot.start) - moment(b.saleable.room_slot.start));

          let otherItems = this.sale.sale_items
            .filter(si => si.saleable_type != 'App\\Models\\Booking' && si.saleable_type != 'App\\Models\\Product');

          let addOnItems = this.sale.sale_items
            .filter(si =>
              si.saleable_type == 'App\\Models\\Product'
              && (si.options == null || typeof(si.options.for_room_slot_id) == 'undefined')
            );

          return [...sortedRoomSlotItems, ...otherItems, ...addOnItems];
        }
      }

      return [];
    },

    visibleAddOns() {
      if (this.showRoomAddOns === false) {
        return this.products;
      }

      // now we need to add Room Add-ons, the correct way
      // TODO: Fix add for each roomslot not just each room
      var roomProducts = [];
      this.roomProducts.forEach(roomProduct => {
        roomProduct.rooms.forEach(room => {
          if (! room.pivot.visible) {
            return;
          }

          if (this.roomsPresent.includes(room.id)) {
            let addOn = JSON.parse(JSON.stringify(roomProduct));
            addOn.for_room = room;
            roomProducts.push(addOn);
          }
        });
      });

      return [...this.products, ...roomProducts];
    },
  },

  watch: {
    initialCart: {
      handler(newCart) {
        // console.log('Checkout::watch initialCart', newCart);
        this.cart = newCart;
        // console.log('Checkout- cart now changed');
      },
      deep: true,
    },
    cart: {
      handler(newCart) {
        // console.log('Checkout::watch Cart', newCart);
        this.$emit('cart-updated', newCart);
      },
      deep: true,
    },
    sale: {
      handler(newSale) {
        // console.log('Checkout::watch Sale', newSale);
        if ((this.locationQuestionsRequired.length == this.requiredLocationQuestionsAnswered.length) && ! this.locationQuestionsMinimisedPressed) {
          this.locationQuestionsMinimised = true;
        } else {
          this.locationQuestionsMinimised = false;
        }
      },
      deep: true,
    },
    displayCheckout: {
      handler(newDisplayCheckout) {
        if (this.fromIframe && newDisplayCheckout == false) {
          // console.log('Checkout::watch displayCheckout', newDisplayCheckout);
          this.$emit('checkout-status-empty');
        }
      }
    },
    vouchersToSpend: {
      handler(newVouchersToSpend) {
        if (this.cartOrSale == 'sale') {
          // console.log('Checkout::watch vouchersToSpend', newVouchersToSpend);
          // a voucher has been added whilst there is a sale going on, we need to deal with that
          this.$emit('vouchers-added-to-sale', newVouchersToSpend);
        }
      }
    },
    checkoutError: {
      handler(newCheckoutError) {
        // we only need to do something if the checkoutError is not longer an error (is null)
        if (newCheckoutError === null) {
          this.disablePayButton = false;
        }
      }
    }
  },

  methods: {
    refreshSale(sale) {
      // console.log('Checkout::refreshSale', sale);

      this.loading(true);

      axios.get(this.route('api.sales.public-show', sale))
        .then((response) => {
          // console.log('refreshSale axios: response.status', response.status)
          // console.log('refreshSale axios: response.data', response.data)
          if (response.status == 200) {
            flash('Sale refreshed', 'success');
            this.sale = response.data;

          } else {
            flash('Error refreshing Sale', 'danger');
            console.log('refreshSale', response.data);
            console.log('refreshSale', response.status);
            console.log('refreshSale', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error refreshing Sale', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('refreshSale:401', error.response.data);
            }
            else if (error.response.status == 404) {
              // 404 not found
              flash('Sale not found, redirecting to index', 'danger');
              window.location.href = route('dash.locations.sales.index', this.sale.location);
            }
            console.log('refreshSale: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('refreshSale: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('refreshSale: Error', error.message);
          }

          this.loading(false);
        });
    }, // end of refreshSale

    takePaymentSale(useVoucher = false, deposit = false) {
      // console.log('Checkout::takePaymentSale', useVoucher, deposit);

      this.locationQuestionsError = null;

      if (this.locationQuestionsRequired.length != this.requiredLocationQuestionsAnswered.length) {
        this.locationQuestionsError = 'Location Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');
        return false;
      }

      if (this.roomQuestionsRequired != this.requiredRoomQuestionsAnswered) {
        this.locationQuestionsError = 'Room Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');
        return false;
      }

      if (this.fromIframe) {
        this.$emit('take-sale-payment', this.vouchersToSpend);
        return false;
      }

      if (this.totalOfVoucherRedemption) {
        // there are some voucher(s) to redeem, but we need to take the sale remaining
        this.$refs.payComponent.takeSalePaymentWithVouchers(this.sale, this.vouchersToSpend);
      } else {
        this.$refs.payComponent.takeSalePayment(this.sale, deposit);
      }
    }, // takePaymentSale

    takePaymentCart(deposit = false) {
      // only used for Carts
      // console.log('takePaymentCart', useVoucher, deposit);

      // need to check that Room and Location Questions have been answered
      this.locationQuestionsError = null;

      if (this.locationQuestionsRequired.length != this.requiredLocationQuestionsAnswered.length) {
        this.locationQuestionsError = 'Location Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');

        return false;
      }

      if (this.roomQuestionsRequired != this.requiredRoomQuestionsAnswered) {
        this.locationQuestionsError = 'Room Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');

        return false;
      }

      let request = {
        location: this.location.slug,
        customer_id: this.cart.customer.id,
        // notes: this.cartNotes, // ??
        discount_id: this.discount ? this.discount.id : null,
      }

      this.locationQuestionsError = null;

      if (this.fromIframe) {
        this.disablePayButton = true;
        if (this.vouchersToSpend.length || this.discount) {
          this.$emit('take-payment', {vouchersToSpend: this.vouchersToSpend, discount: this.discount});
        } else {
          this.$emit('take-payment');
        }
        return false;
      }

      // TODO: need to sort non-iFrame version, if we are going to proceed with this

      this.loading(true);
      this.disableCartEchoUpdate();
      axios.patch(this.route('api.cart.checkout', this.cart), request)
        .then((response) => {
          // console.log('response back from axios', response);
          // console.log('response status back from axios', response.status);
          if (response.status == 200) {
            this.sale = response.data.sale;
            // this.cart = response.data.cart;

            // console.log('cartCheckout() completed', response.data.sale);
            this.saleUrl = response.data.sale.payment_url;
            this.changeInternalUrl(this.saleUrl);

            flash('Cart converted to Sale', 'success');

            this.$nextTick(() => {
              if (this.vouchersToSpend.length) { // || useVoucher === true
                let voucherTransactions = [];
                this.vouchersToSpend.forEach(v => {
                  voucherTransactions.push({
                    amount: v.cashValue,
                    booked_by: 'W',
                    cart_reference: v.reference,  // don't change this or everything will break
                    from: 'C',
                    transaction_reference: null,
                    transaction_type_id: 15,
                  });
                })

                let request = {
                  transactions: voucherTransactions,
                };

                axios.post(this.route('api.sales.transactions.store', this.sale.hashid), request)
                  .then((response) => {
                    if (response.status == 200) {
                      console.log('api.sales.transactions.store after VOUCHER redemption', response.data);
                      if (response.data.left_to_pay == 0) {
                        window.location.href = this.route('location.payment.success', [this.location, response.data]);
                      } else {
                        window.location.href = response.data.customerRedirect;
                      }

                    } else {
                      flash('Error submitting new Transactions', 'danger');
                      console.log('submitNewTransactions', response.data);
                      console.log('submitNewTransactions', response.status);
                      console.log('submitNewTransactions', response.statusText);
                    }

                    this.loading(false);
                  })
                  .catch((error) => {
                    flash('Error submitting new Transactions', 'danger');
                    if (error.response) {
                      // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
                      if (error.response.status == 422) {
                        console.log('submitNewTransactions: laravel validation error', error.response.data);
                      }
                      // else if HTTP_CONFLICT to many saleables or over lap
                      else if (error.response.status == 409) {
                        this.lockError = error.response.data;
                      }
                      // else if HTTP_FORBIDDEN on enough permissions
                      else if (error.response.status == 401) {
                        // else if HTTP_UNAUTHORIZED not authorized
                        console.log('submitNewTransactions:401', error.response.data);
                      }
                      else {
                        console.log('submitNewTransactions: Response error', error.response.data, error.response.status, error.response.headers);
                      }
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.error('submitNewTransactions: Request error', error.request);
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.error('submitNewTransactions: Error', error.message);
                    }
                    this.loading(false);
                  });

              } else {
                this.disablePayButton = true;
                this.$refs.payComponent.takeSalePayment(this.sale, deposit === true ? true : false);
              }
            });
          } else {
            this.enableCartEchoUpdate();

            flash('Error with Cart checkout', 'danger');
            console.log('cartCheckout', response.data);
            console.log('cartCheckout', response.status);
            console.log('cartCheckout', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          this.enableCartEchoUpdate();

          let showError = true;

          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartCheckout:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409 && error.response.data.message == 'Blocklist email') {
              // else if HTTP_CONFLICT && Blocklist Email

              $(this.$refs.loadingModal).modal('show');
              showError = false;
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartCheckout:409', error.response.data);
              this.locationQuestionsError = error.response.data.message;
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartCheckout:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartCheckout:401', error.response.data);
            } else {
              console.log('cartCheckout: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartCheckout: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartCheckout: Error', error.message);
          }

          this.loading(false);

          if (showError) {
            flash('Error with Cart checkout', 'danger');
            console.log('error.response', error.response)
          }
        });
    }, // takePaymentCart()

    discountButtonClicked() {
      this.discountButtonDisable = true;
      this.showDiscountSection = true;

      this.voucherButtonDisable = false;
      this.showVoucherSection = false;

      this.$nextTick(() => {
        document.getElementById('discountSection').scrollIntoView({ behavior: 'smooth', block: 'start',});
        this.$refs.discountCode.focus();
      });
    },

    voucherButtonClicked() {
      this.voucherButtonDisable = true;
      this.showVoucherSection = true;

      this.discountButtonDisable = false;
      this.showDiscountSection = false;

      this.$nextTick(() => {
        this.$refs.voucherSection.scrollIntoView({ behavior: 'smooth' })
        this.$refs.voucherCode.focus();
      });
    },

    cancelRedeeming(resetType = 'DISCOUNT') {
      this.discountButtonDisable = false;
      this.voucherButtonDisable = false;

      this.showDiscountSection = false;
      this.showVoucherSection = false;

      if (resetType == 'VOUCHER') {
        // console.log('cancelRedeeming: VOUCHER');
        this.voucherCode = null;
        this.voucherError = false;
      } else {
        // console.log('cancelRedeeming: DISCOUNT');
        this.discountCode = null;
        this.discount = null;
        this.discountingError = false;
        this.discountingSuccess = false;
      }
    },

    submitDiscountCode() {
      // validation
      if (! this.discountCode) {
        flash('No discount code entered', 'danger');

        return false;
      }

      if (this.cartOrSale == 'cart') {
        var request = {
          discountCode: this.discountCode,
          cart_id: this.cart.id,
        }
      } else {
        var request = {
          discountCode: this.discountCode,
          sale_id: this.sale.id,
        }
      }

      this.discountingError = null;
      this.discountingSuccess = false;

      this.loading(true, this.$refs.confirmModalBody);

      axios.post(this.route('api.locations.discounts.show', this.location.slug), request)
        .then((response) => {
          this.loading(false);

          if (response.status == 204) {
            let msg = 'There is no active Discount with this code';
            flash(msg, 'warning');
            this.discountingError = msg;
          } else if (response.status == 200) {
            // now we need to check if it a 2pax Stu
            if (this.cartOrSale == 'sale' && this.sale.sale_items.filter(si => si.saleable_type == "App\\Models\\Booking" == 2 && si.saleable.players).length && response.data.method == 'STUDENT') {
              let err = 'Student Discounts cannot be used on a cart containing a 2-player Booking';
              flash(err, 'error');
              this.discountingError = err;
            }
            if (this.cartOrSale == 'cart' && this.cart.cart_items.filter(ci => ci.quantity == 2 && ci.cartable_type == "App\\Models\\RoomSlot").length && response.data.method == 'STUDENT') {
              let err = 'Student Discounts cannot be used on a cart containing a 2-player Booking';
              flash(err, 'error');
              this.discountingError = err;
            } else if (response.data.percentage && this.inPromo && this.locationDiscount.percentage > response.data.percentage) {
              let err = 'Today\'s discount is greater than your discount code';
              flash(err, 'error');
              this.discountingError = err;
            } else {
              this.discountingSuccess = true;
              this.discount = response.data;
              if (this.cartOrSale == 'cart') {
                this.addDiscountToCart(response.data);
              } else {
                this.addDiscountToSale(response.data);
              }
            }
          } else {
            flash('Error fetching Discount from code', 'error');
            console.log('submitDiscountCode', response.data);
            console.log('submitDiscountCode', response.status);
            console.log('submitDiscountCode', response.statusText);
          }
        })
        .catch((error) => {
          flash('Error fetching Discount from code', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('submitDiscountCode:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('submitDiscountCode:409', error.response.data);
              flash(error.response.data, 'error');
              this.discountingError = error.response.data;
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('submitDiscountCode:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('submitDiscountCode:401', error.response.data);
            } else {
              console.log('submitDiscountCode: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('submitDiscountCode: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('submitDiscountCode: Error', error.message);
          }

          this.loading(false);
        }); // axios
    }, // submitDiscountCode

    removeVoucher(voucher) {
      // console.log('Checkout::removeVoucher', voucher);
      if (this.vouchersToSpend.length && this.vouchersToSpend.some(v => v.reference == voucher.reference)) {
        var voucherIndex = this.vouchersToSpend.findIndex(v => v.reference == voucher.reference);
        if (voucherIndex != -1) {
          Vue.delete(this.vouchersToSpend, voucherIndex);
        }
      }
    },

    submitVoucherCode() {
      // console.log('Checkout::submitVoucherCode', this.voucherCode);
      // validation
      if (! this.voucherCode) {
        flash('No voucher code entered', 'danger');
        return false;
      }
      if (this.vouchersToSpend.length && this.vouchersToSpend.some(v => v.reference.toLowerCase() == this.voucherCode.toLowerCase())) {
        // already in the stack of vouchers, so bail
        flash('Voucher already entered', 'danger');
        return false;
      }

      let request = {
        voucherCode: this.voucherCode,
      }
      this.voucherError = null;

      this.loading(true, this.$refs.confirmModalBody);

      axios.post(this.route('api.locations.vouchers.show', this.location.slug), request)
        .then((response) => {
          this.loading(false);
          // console.log('api.locations.vouchers.show');
          // console.log(response.data);

          if (response.status == 200) {
            if (response.data.has_expired) {
              flash('This voucher has expired', 'error');
              this.voucherError = 'This voucher has expired.';

              return false;
            }

            if (this.cartOrSale == 'cart') {
              if (response.data.type == 'M' && response.data.amount > this.cart.price) {
                flash('This voucher is greater than the sale', 'error');
                this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';

                return false;
              } else {
                //is an off-peak or peak voucher

                if (response.data.type == 'O' && this.location.prices.find(price => price.price_for == response.data.amount).offpeak > this.cart.price) {
                  flash('This voucher is greater than the sale', 'error');
                  this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';

                  return false;
                }
                if (response.data.type == 'P' && this.location.prices.find(price => price.price_for == response.data.amount).peak > this.cart.price) {
                  flash('This voucher is greater than the sale', 'error');
                  this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';
                  return false;
                }
              }
            } else {
              // is a sale
              if (response.data.type == 'M' && response.data.amount > this.sale.left_to_pay) {
                flash('This voucher is greater than the sale', 'error');
                this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';

                return false;
              } else {
                //is an off-peak or peak voucher

                if (response.data.type == 'O' && this.location.prices.find(price => price.price_for == response.data.amount).offpeak > this.sale.left_to_pay) {
                  flash('This voucher is greater than the sale', 'error');
                  this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';

                  return false;
                }
                if (response.data.type == 'P' && this.location.prices.find(price => price.price_for == response.data.amount).peak > this.sale.left_to_pay) {
                  flash('This voucher is greater than the sale', 'error');
                  this.voucherError = 'This voucher is greater than the sale, please contact us to redeem.';
                  return false;
                }
              }
            }

            this.voucherError = null;
            this.vouchersToSpend.push(response.data);
            this.voucherCode = null;

            this.$nextTick(() => {
              this.$refs.voucherCheckout.scrollIntoView({ behavior: 'smooth' })
            });

          } else {
            flash('Error fetching Voucher from code', 'error');
            console.log('submitVoucherCode', response.data);
            console.log('submitVoucherCode', response.status);
            console.log('submitVoucherCode', response.statusText);
          }
        })
        .catch((error) => {
          flash('Error fetching Voucher from code', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('submitVoucherCode:422', error.response.data);
            } else if (error.response.status == 404) {
              let msg = 'There is no (unredeemed) Voucher with this code';
              flash(msg, 'warning');
              this.voucherError = msg;
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT

              console.log('submitVoucherCode:409', error.response.data);

              flash(error.response.data, 'error');
              this.voucherError = error.response.data;

            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('submitVoucherCode:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('submitVoucherCode:401', error.response.data);
            } else {
              console.log('submitVoucherCode: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('submitVoucherCode: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('submitVoucherCode: Error', error.message);
          }

          this.loading(false);
        }); // axios
    }, // submitVoucherCode

    saleEmptyConfirmation() {
      // console.log('cartEmptyConfirmation');

      const self = this;

      $('#emptySale').confirmation('dispose');

      // confirmation popover
      let options = {
        container: 'body',
        rootSelector: '#emptySale',
        title: 'Cancel and clear this Sale?',
        popout: true,
        singleton: true,
        btnOkClass: 'btn btn-sm btn-dark-green',
        btnCancelClass: 'btn btn-sm btn-red',
        placement: 'bottom',
        trigger: 'manual',
        onConfirm(value) {
          self.$nextTick(function () {
            self.deleteSale();
          });
        },
      };

      $('#emptySale').confirmation(options);
      $('#emptySale').confirmation('show');
    }, // saleEmptyConfirmation()

    deleteSale() {
      // console.log('deleteSale');

      this.loading(true);

      axios.delete(this.route('api.sales.public-destroy', this.sale))
        .then((response) => {
          // console.log('axios of api.sale.destroy', response.data);
          // console.log('response.status', response.status);
          if (response.status == 204) {

            flash('Sale deleted', 'success');
            window.location.reload();

          } else {
            flash('Error deleting Sale', 'danger');
            console.log('deleting Sale', response.data);
            console.log('deleting Sale', response.status);
            console.log('deleting Sale', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error deleting Sale', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            if (error.response.status == 422) {
              console.log('deleteSale: laravel validation error', error.response.data);
            }
            // else if HTTP_CONFLICT
            else if (error.response.status == 409) {
              console.log('deleteSale: HTTP_CONFLICT error', error.response.data);
            }
            // else if HTTP_FORBIDDEN on enough permissions
            else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('deleteSale:401', error.response.data);
            }
            else {
              console.log('deleteSale: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('deleteSale: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('deleteSale: Error', error.message);
          }
          this.loading(false);
        });
    }, // deleteSale()

    cartEmptyConfirmation() {
      // console.log('cartEmptyConfirmation');

      const self = this;

      $('#emptyCart').confirmation('dispose');

      // confirmation popover
      let options = {
        container: 'body',
        rootSelector: '#emptyCart',
        title: 'Empty your cart?',
        popout: true,
        singleton: true,
        btnOkClass: 'btn btn-sm btn-dark-green',
        btnCancelClass: 'btn btn-sm btn-red',
        placement: 'bottom',
        trigger: 'manual',
        onConfirm(value) {
          self.$nextTick(function () {
            self.cartEmpty();
          });
        },
      };

      $('#emptyCart').confirmation(options);
      $('#emptyCart').confirmation('show');
    }, // cartEmptyConfirmation()

    cartEmpty() {
      // console.log('Checkout::cartEmpty()');

      if (this.fromIframe) {
        // console.log('Checkout::cartEmpty - about to emit `empty-cart`');
        this.$emit('empty-cart');
        return false;
      }

      let request = {
        location: this.location.slug,
      }

      this.loading(true);
      axios.delete(this.route('api.cart.destroy', this.cart), {data: request})
        .then((response) => {
          if (response.status == 200) {
            this.cart = response.data;
          } else {
            flash('Error emptying Cart', 'danger');
            console.log('cartEmpty', response.data);
            console.log('cartEmpty', response.status);
            console.log('cartEmpty', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error emptying Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartEmpty:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartEmpty:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartEmpty:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartEmpty:401', error.response.data);
            } else {
              console.log('cartEmpty: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartEmpty: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartEmpty: Error', error.message);
          }
          this.loading(false);
        });
    },

    addDiscountToSale(discount) {
      // console.log('addDiscountToSale()');

      let request = {
        discount_id: this.discount.id,
      }

      // console.log('request', request);

      this.loading(true);

      axios.post(this.route('api.sales.discount.store', this.sale), request)
        .then((response) => {
          if (response.status == 200) {
            console.log('axios response is:', response.data);

            if (this.fromIframe) {
              this.$emit('sale-updated', response.data);
            } else {
              this.sale = response.data;
            }
          } else {
            flash('Error adding Discount to Cart', 'danger');
            console.log('addDiscountToSale', response.data);
            console.log('addDiscountToSale', response.status);
            console.log('addDiscountToSale', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error adding Discount to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('addDiscountToSale:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('addDiscountToSale:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('addDiscountToSale:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('addDiscountToSale:401', error.response.data);
            } else {
              console.log('addDiscountToSale: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('addDiscountToSale: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('addDiscountToSale: Error', error.message);
          }
          this.loading(false);
        });
    }, // addDiscountToSale()

    addDiscountToCart(discount) {
      // console.log('addDiscountToCart()');

      let request = {
        location: this.location.slug,
      }

      if (discount) {
        request.discount_id = discount.id;
      } else {
        request.discount_id = null;
      }

      // console.log('request', request);

      this.loading(true);
      axios.patch(this.route('api.cart.discount', this.cart), request)
        .then((response) => {
          if (response.status == 200) {
            // console.log('axios response:');
            // console.log(response.data);
            this.cart = response.data;
          } else {
            flash('Error adding Discount to Cart', 'danger');
            console.log('addDiscountToCart', response.data);
            console.log('addDiscountToCart', response.status);
            console.log('addDiscountToCart', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error adding Discount to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('addDiscountToCart:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('addDiscountToCart:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('addDiscountToCart:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('addDiscountToCart:401', error.response.data);
            } else {
              console.log('addDiscountToCart: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('addDiscountToCart: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('addDiscountToCart: Error', error.message);
          }
          this.loading(false);
        });
    }, // addDiscountToCart()

    updateCustomer() {
      // console.log('updateCustomer', this.customer);

      try {
        new Address(this.customer.email);
      } catch (error) {
        flash('Error with email address', 'danger');
        flash(error, 'danger');
        return;
      }

      let request = {
        email: this.customer.email,
        name: this.customer.name,
        no_mail: ! this.marketingConsent,
      }

      this.loading(true, this.$refs.customerPane);

      axios.patch(this.route('api.customers.public-update', this.customer), request)
        .then((response) => {
          if (response.status == 200) {
            console.log('axios response:');
            console.log(response.data);
            this.$set(this.cart, 'customer', response.data);
            this.editingCustomer = false;
            this.marketingConsent = ! response.data.no_mail;
          } else {
            flash('Error updating Customer details', 'danger');
            console.log('updateCustomer', response.data);
            console.log('updateCustomer', response.status);
            console.log('updateCustomer', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error updating Customer details', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('updateCustomer:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('updateCustomer:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('updateCustomer:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('updateCustomer:401', error.response.data);
            } else {
              console.log('updateCustomer: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('updateCustomer: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('updateCustomer: Error', error.message);
          }
          this.loading(false);
        });
    },

    addProduct(product, forRoomSlotId = null) {
      // has for_room_slot_id as a field
      // console.log('Checkout::addProduct', product, forRoomSlotId);

      let request = {
        location: this.location.slug,
        quantity: 1,
        soldFor: product.sale_price,
      }

      if (this.cartOrSale == 'cart') {
        request.cartable = 'App\\Models\\Product:' + product.id;
      } else {
        request.saleable = 'App\\Models\\Product:' + product.id;
      }

      if (forRoomSlotId) {
        if (this.cartOrSale == 'cart') {
          request.options = {
            for_room_slot_ids: {
              [forRoomSlotId]: 1,
            },
          };
        } else {
          request.options = {
            for_room_slot_id: forRoomSlotId,
          };
        }
      } else if (product.for_room) {
        // this bit is now moot, and need revision TODO
        // let roomIds = {};
        // request.options = {};
        // if (this.cartOrSale == 'cart') {
        //   roomIds[product.for_room.id] = 1;
        //   request.options.for_room_ids = roomIds;
        // } else {
        //   request.options.for_room_slot_id = forRoomSlotId;
        // }
      }

      if (this.cartOrSale == 'cart') {
        var axiosRoute = this.route('api.cart.cart-items.store', this.cart);
      } else {
        var axiosRoute = this.route('api.sales.sale-items.public-store', this.sale);
      }

      // console.log('axios', axiosRoute, request);

      this.loading(true);
      axios.post(axiosRoute, request)
        .then((response) => {
           if (response.status == 200) {
            // console.log('updated', response.data);
            if (this.cartOrSale == 'cart') {
              this.cart = response.data;
            } else {
              this.sale = response.data;
            }

            flash('Product added to ' + this.cartOrSale.charAt(0).toUpperCase() + this.cartOrSale.slice(1), 'success');

          } else {
            flash('Error adding Product to ' + this.cartOrSale.charAt(0).toUpperCase() + this.cartOrSale.slice(1), 'error');
            console.log('addProduct', response.data);
            console.log('addProduct', response.status);
            console.log('addProduct', response.statusText);
          }

          this.loading(false);
          this.payButtonDisable = false;
        })
        .catch((error) => {
          flash('Error adding Product to ' + this.cartOrSale.charAt(0).toUpperCase() + this.cartOrSale.slice(1), 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('addProduct:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('addProduct:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('addProduct:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('addProduct:401', error.response.data);
            } else {
              console.log('addProduct: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('addProduct: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('addProduct: Error', error.message);
          }
          this.loading(false);
          this.payButtonDisable = false;
        });
    }, // addProduct()

    expandLocationQuestions() {
      $('.tooltip').tooltip('hide');
      this.locationQuestionsMinimisedPressed = true;
      this.locationQuestionsMinimised = false;
    },

    cartRefreshed(cart) {
      // console.log('Checkout::cartRefreshed', cart);
      this.cart = cart;
    }, // cartRefreshed()

    saleRefreshed(sale) {
      // console.log('Checkout::saleRefreshed', sale);
      this.sale = sale;
    }, // saleRefreshed()

    saleUpdatedFromItemDetailsRow(sale) {
      // console.log('Checkout::saleUpdatedFromItemDetailsRow', sale);
      // because this has come from a child of Checkout, Checkout needs to push this to the parent.
      if (this.fromIframe) {
        this.$emit('sale-updated', sale);
      } else {
        this.saleRefreshed(sale);
      }
    }, // saleUpdatedFromItemDetailsRow()

    getCustomerDetails() {
      // console.log('Checkout::getCustomerDetails');
      this.$emit('get-customer-details');
    },

    addExtraItemsToCart() {
      // currently only clickable if from an iFrame mode, as it just emits a button click of the calendar.
      // console.log('Checkout::addExtraItemsToCart');
      this.$emit('click-calendar-button');
    },

    changeInternalUrl(theNewUrl) {
      var theCurrentUrl = location.toString().replace(location.search, "");

      // Google relies upon seeing where we came from
      history.pushState({},"",theNewUrl);

      this.$nextTick(() => {
        // Meta Pixel
        if (typeof fbq !== 'undefined') {
          fbq('track', 'PageView');
        }

        // Google
        if (window.dataLayer) {
          window.dataLayer.push({
            page_location: theNewUrl,
            page_referrer: theCurrentUrl,
          });
        }
      });
    },

    /* ===============
     * Echo methods
     */

    cartSavedEvent(event) {
      // console.log('Checkout::cartSavedEvent(event)', event);
      if (this.fromIframe) {
        return;
      }

      if (! this.disableCartEchoUpdateFlag) {
        this.cart = event.cart;
      } else {
        this.temporaryCart = event.cart;
      }
    },

    enableCartEchoUpdate() {
      if (this.fromIframe) {
        return;
      }

      this.disableCartEchoUpdateFlag = false;

      if (this.temporaryCart) {
        this.cart = this.temporaryCart;
        this.temporaryCart = null;
      }
    },

    disableCartEchoUpdate() {
      this.disableCartEchoUpdateFlag = true;
      this.temporaryCart = null;
    },

    echoInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.channel('cart.session.' + this.cart.session)
        .listen('Cart.CartSaved', this.cartSavedEvent);

      this.enableCartEchoUpdate();
    },

    echoDeInitCart() {
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      Echo.leave('cart.session.' + this.cart.session);
    },

    /*
     * END Echo methods
     * =============== */
  },

  mounted() {
    if (! this.fromIframe) {
      this.echoInitCart();
    }
    this.marketingConsent = ! this.customer.no_mail;

    if (this.cartOrSale == 'sale' && this.sale.transactions.length && this.sale.totalTransactionsAmount != 0) {
      // we are dealing with a sale with transactions,

      if (this.requiredLocationQuestionsAnswered) {
        // all location questions are answered, so minimise it
        this.locationQuestionsMinimised = true;
      }

      if (this.locationQuestionsRequired.length) {
        // hide addOns
        this.showLocationAddOns = false;

      }
    }
  },

  beforeDestroy() {
    if (! this.fromIframe) {
      this.echoDeInitCart();
    }
  },
}
</script>
